import { Button } from 'antd'

import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '@/src/lib'

interface SelectedFilterButtonProps {
  onClick: () => void
  children: React.ReactNode
}

export const SelectedFilterButton = ({
  onClick,
  children,
}: SelectedFilterButtonProps) => (
  <Button
    color='default'
    variant='filled'
    onClick={onClick}
    style={{
      fontWeight: 'bold',
      color: '#06686B',
    }}
    icon={<FontAwesomeIcon icon='xmark' />}
    iconPosition='end'
  >
    {children}
  </Button>
)
